import { FiltersValues } from "components/elements/DataTable/DataTable";
import { useLazyGetEnumInfoQuery } from "store/system";

function useEnumsFilters<T>() {
  const [getEnumInfo] = useLazyGetEnumInfoQuery();

  const transformEnumsIntoFilters = (enumObject: Record<string, number>) => {
    const filters = Object.keys(enumObject).map((key) => ({
      text: key,
      value: enumObject[key],
    }));
    return filters;
  };

  const getFilters = async ({
    name,
    callback,
  }: {
    name: string;
    callback(value: FiltersValues): void;
  }) => {
    try {
      const payload = await getEnumInfo({ enumName: name }).unwrap();
      if (payload) {
        callback(transformEnumsIntoFilters(payload));
      }
    } catch (error) {
      console.error("GetEnumInfo Error", error);
    }
  };

  const getOnFilter = (key: keyof T) => (value: T[keyof T], record: T) =>
    record[key] === value;

  return { getFilters, getOnFilter };
}

export default useEnumsFilters;
